import React from 'react';
import { useAuth } from '../../context/AuthContext';
import AccessDenied from '../../pages/user/AccessDenied';

const PermissionRoute = ({ permission, children }) => {
  const { user } = useAuth();
  
  if (!user) return null;

  const effectiveRole = (user.role === 'user' ? 'owner' : user.role) || 'cashier';
  
  // Owners and admins bypass permission checks completely
  if (['owner', 'admin', 'super-admin'].includes(effectiveRole)) {
    return children;
  }

  // Check if staff has the explicit permission
  const hasPermission = user.permissions && user.permissions.includes(permission);

  if (!hasPermission) {
    return <AccessDenied />;
  }

  return children;
};

export default PermissionRoute;
